import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getListMedia(params = {}) {
    const { media_type, cursor, limit = 10, q } = params;
    return api.get('/media', {
      params: omitBy({ media_type, cursor, limit, q }, isNil),
    });
  },

  getMediaById(id) {
    return api.get(`/media/${id}`);
  },

  updateMedia(id, payload) {
    return api.put(`/media/${id}`, payload);
  },
  deleteMedia(id) {
    return api.delete(`/media/${id}`);
  },
  createMedia(payload) {
    return api.post('/media', payload);
  },
};
